module.exports = __webpack_public_path__ + "img/link_logo_dark.351ec590.svg";